module.exports = "/images/vendor/desiigner-svg/svg/places/golden-gate.svg?ace17960654ae1d988131be4b16d0f62";